// App.js
import React, { useState, useMemo, useEffect } from "react"; // Added useEffect
import "./App.css";
import { products } from "./data";
import logo from "./assets/logo.png";

function App() {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategories, setActiveCategories] = useState(["all"]);
  const [sortOption, setSortOption] = useState("default");

  // NEW: State for pagination
  const [visibleCount, setVisibleCount] = useState(12); // Start by showing 12 items

  // --- HANDLERS ---
  const handleCategoryClick = (category) => {
    // ... (Keep your existing category logic here) ...

    // (Existing logic...)
    if (category === "all") {
      setActiveCategories(["all"]);
    } else {
      let newCategories = [...activeCategories];
      if (newCategories.includes("all")) newCategories = [];
      if (newCategories.includes(category)) {
        newCategories = newCategories.filter((c) => c !== category);
      } else {
        newCategories.push(category);
      }
      if (newCategories.length === 0) newCategories = ["all"];
      setActiveCategories(newCategories);
    }
  };

  // NEW: Reset visible count when filters change
  // If user searches or filters, we should reset to the top
  useEffect(() => {
    setVisibleCount(12);
  }, [searchTerm, activeCategories, sortOption]);

  // NEW: Load More Handler
  const showMoreItems = () => {
    setVisibleCount((prevValue) => prevValue + 12); // Load 12 more
  };

  // --- FILTER & SORT LOGIC ---
  // --- FILTER & SORT LOGIC ---
  const filteredProducts = useMemo(() => {
    let result = products;

    // 1. Search Filter
    if (searchTerm) {
      result = result.filter((product) =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // 2. Category Filter
    if (!activeCategories.includes("all")) {
      result = result.filter((product) =>
        activeCategories.includes(product.category)
      );
    }

    // 3. Sorting
    if (sortOption === "name-asc") {
      result = [...result].sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOption === "name-desc") {
      result = [...result].sort((a, b) => b.name.localeCompare(a.name));
    } else {
      // --- NEW LOGIC HERE ---
      // If sort is "default", reverse the list to show NEWEST items first
      result = [...result].reverse();
    }

    return result;
  }, [searchTerm, activeCategories, sortOption]);

  // CALCULATE COUNTS
  const categoryCounts = useMemo(() => {
    // Initialize counters
    const counts = {
      all: products.length,
      outerwear: 0,
      tops: 0,
      bottoms: 0,
      hats: 0,
      accessories: 0,
    };

    // Loop through products and count them
    products.forEach((product) => {
      // If the category exists in our list, increment it
      if (counts[product.category] !== undefined) {
        counts[product.category]++;
      }
    });
    return counts;
  }, []);
  // --- JSX RENDER ---
  return (
    <div className="container">
      <header>
        <div className="logo-container">
          {/* 1. Base Image (Visible always) */}
          <img className="logo-base" src={logo} alt="DVRKSIDE" />

          {/* 2. Glitch Image (Visible only during animation) */}
          <img className="logo-glitch" src={logo} alt="" aria-hidden="true" />
        </div>
        {/* <h1>DVRKSIDE</h1> */}
        <p className="bio">
          [SYSTEM READY]
          <br />
          CURATED TECHWEAR & UTILITY GEAR
        </p>
      </header>

      <section className="controls">
        {/* ... (Keep your existing controls code) ... */}
        <div className="controls-top">
          <div className="search-wrapper">
            <input
              type="text"
              className="search-input"
              placeholder="> SEARCH DATABASE_"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="sort-wrapper">
            <select
              className="sort-select"
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
            >
              <option value="default">SORT: DEFAULT</option>
              <option value="name-asc">NAME (A-Z)</option>
              <option value="name-desc">NAME (Z-A)</option>
            </select>
          </div>
        </div>

        <div className="filter-buttons">
          {["all", "outerwear", "tops", "bottoms", "hats", "accessories"].map(
            (cat) => (
              <button
                key={cat}
                className={`filter-btn ${
                  activeCategories.includes(cat) ? "active" : ""
                }`}
                onClick={() => handleCategoryClick(cat)}
              >
                {/* Show Category Name */}
                {cat}

                {/* Show Count in Brackets */}
                <span className="cat-count">[{categoryCounts[cat] || 0}]</span>
              </button>
            )
          )}
        </div>
      </section>

      {/* Grid */}
      <div className="grid">
        {filteredProducts.length > 0 ? (
          // MODIFIED: We slice the array to only show 'visibleCount' items
          filteredProducts.slice(0, visibleCount).map((product) => (
            <article key={product.id} className="card">
              <a href={product.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={product.image}
                  alt={product.name}
                  className="card-image"
                />
                <div className="card-details">
                  <span className="card-tag">{product.category}</span>
                  <h2 className="card-title">{product.name}</h2>
                  <span className="card-price">{product.price}</span>
                  <div className="buy-btn">Acquire Unit</div>
                </div>
              </a>
            </article>
          ))
        ) : (
          <div className="no-results">[ERROR 404] No items found.</div>
        )}
      </div>

      {/* NEW: LOAD MORE BUTTON */}
      {/* Only show this button if there are more items to show */}
      {visibleCount < filteredProducts.length && (
        <div style={{ textAlign: "center", margin: "40px 0" }}>
          <button className="load-more-btn" onClick={showMoreItems}>
            [ EXPAND DATABASE ]
          </button>
        </div>
      )}

      <footer>
        <p>
          OPERATED BY <span className="glitch-text">DVRKSIDE</span>
        </p>
        <br />
        <a href="https://instagram.com/dvrkside.co" className="social-link">
          INSTAGRAM DATABASE
        </a>
      </footer>
    </div>
  );
}

export default App;
